var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods_detail" },
    [
      _c("loading", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.ifShowLoading,
            expression: "ifShowLoading"
          }
        ]
      }),
      _vm._v(" "),
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "header_img" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search_btn" },
          [
            _c(
              "van-tabs",
              {
                attrs: { swipeable: "", animated: "" },
                model: {
                  value: _vm.active,
                  callback: function($$v) {
                    _vm.active = $$v
                  },
                  expression: "active"
                }
              },
              [
                _c(
                  "van-tab",
                  { attrs: { title: "箱码" } },
                  [_c("one-goods-info", { attrs: { oneBox: _vm.oneBox } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "van-tab",
                  { attrs: { title: "发货单" } },
                  [_c("all-goods-info", { attrs: { allBox: _vm.allBox } })],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54d86694", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54d86694","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/scanQrCodes/goodsDetailList.vue
// module id = null
// module chunks = 